import React from 'react';

import { GenerateListIcon } from './GenerateListIcon';
import { ListIconsProps } from './types';

export const EditIcon: React.FC<ListIconsProps> = ({ tooltipMessageKey = 'layout.action.edit', ...rest }) => (
  <GenerateListIcon {...rest} color="blue-light" kind="pencil" tooltipMessageKey={tooltipMessageKey} />
);
